import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const deleteComment = async (commentId) => {
  await axios.apiCadernoVirtual.delete("/socialmedia-service/comments", {
    params: {
      id: commentId,
      excludedBy: _cookies.getItem("auth").user?.alunoid,
    },
  });
};

export const useDeleteComment = ({ postId, commentId, config } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: () => deleteComment(commentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["postComments", { postId }] });
    },
  });
};
